import axios from "axios";
import { createCurri } from "../types/curriculum.interface";

class CurriService1 {
  async create(value: createCurri) {
    // console.log(value);
    return await axios.post("curriculum", value);
  }

  async getAll() {
    return await axios.get("curriculum");
  }

  async getByType(type: string) {
    return await axios.get(`curriculum/${type}`);
  }

  async getById(id: number) {
    return await axios.get(`curriculum/id/${id}`);
  }

  async updateById(id: number, value: any) {
    return await axios.put(`curriculum/update/${id}`, value);
  }

  async deletecCurriculum(id: number) {
    return await axios.delete(`curriculum/${id}`);
  }

  async findCurri(body: { level: string; curriCode: string }) {
    return await axios.post(`curriculum/findCurri`, { ...body });
  }
}
const CurriService = new CurriService1();

export default CurriService;
